import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaUserEdit, FaTrash, FaPlus, FaLock } from "react-icons/fa";
import { IoMdLock } from "react-icons/io";
import { BsUnlockFill } from "react-icons/bs";
import {
  useToast,
} from '@chakra-ui/react';
import ConfirmModal from "../components/ConformModel/ConfirmModal";
export default function AdminDashboard() {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [editAdmin, setEditAdmin] = useState(null);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [showAddPass, setShowAddPass] = useState(false);
  const [showCurrentPass, setShowCurrentPass] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);


  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
    role: "admin",
  });
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null);


  const toast = useToast();

  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchAdmins = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/api/v1/adminManagment/admins");

      // HIDE SuperSurya HERE ↓↓↓
      const filtered = res.data.data.filter(
        (a) => a.email !== "admin@arrowcoders.com"
      );

      setAdmins(filtered);


    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePasswordChange = (e) => {
    setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editAdmin) {
        await axios.put(`/api/v1/adminManagment/${editAdmin._id}`, formData, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast({
          title: "Employee Edited Sucessfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        await axios.post("/api/v1/adminManagment/create-admin", formData);
        toast({
          title: "Employee Created Sucessfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      }
      setShowModal(false);
      setFormData({ fullName: "", email: "", password: "", role: "admin" });
      fetchAdmins();
    } catch (error) {
      console.error(error.response?.data);
      toast({
        title: "Error saving admin",
        status: "error",
        duration: 3000,
        isClosable: true,
      });

    }
  };


  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      toast({
        title: "New password and confirm password do not match!",
        status: "error",
        duration: 3000,
        isClosable: true,
      });

      return;
    }

    try {
      await axios.put(
        `/api/v1/adminManagment/change-password/${selectedAdmin._id}`,
        passwordData
      );

      toast({
        title: "Password updated successfully!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      setShowPasswordModal(false);
      setPasswordData({ currentPassword: "", newPassword: "" });

    } catch (error) {
      console.error(error.response?.data);
      toast({
        title: "Error updating password",
        status: "error",
        duration: 3000,
        isClosable: true,
      });

    }
  };



  const confirmDelete = async () => {
    try {
      await axios.delete(`/api/v1/adminManagment/${deleteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast({
        title: "Admin deleted successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      fetchAdmins();
    } catch (error) {
      console.error(error);
      toast({
        title: "Error deleting admin",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setShowConfirm(false);
      setDeleteId(null);
    }
  };


  const handleEdit = (admin) => {
    setEditAdmin(admin);
    setFormData({
      fullName: admin.fullName,
      email: admin.email,
      role: admin.role,
    });
    setShowModal(true);
  };

  const handleChangePassword = (admin) => {
    setSelectedAdmin(admin);
    setShowPasswordModal(true);
  };

  const handleAddNew = () => {
    setEditAdmin(null);
    setFormData({ fullName: "", email: "", password: "", role: "admin" });
    setShowModal(true);
  };

  if (loading)
    return (
      <p className="text-center mt-6 text-[var(--primary-solid)]">Loading...</p>
    );

  return (
    <div className="p-6 min-h-[80vh] bg-white text-[var(--black-text)]">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold text-[var(--primary-solid)]">
          Employee Management
        </h2>
        <button
          className="px-4 py-2 rounded-md flex items-center gap-2 bg-gradient-to-r from-[var(--primary-solid)] to-[var(--primary-dark)] text-white hover:shadow-md transition"
          onClick={handleAddNew}
        >
          <FaPlus /> Add Employee
        </button>
      </div>

      <div className="overflow-x-auto bg-white rounded-2xl shadow-lg border-2 border-gray-200">
        <table className="w-full table-auto whitespace-nowrap text-sm text-[var(--black-text)]">
          <thead className="">
            <tr className="bg-gradient-to-r from-[var(--primary-solid)] to-[var(--primary-dark)] text-white text-md uppercase p-5 font-semibold">
              <th className="py-3 px-4 text-left ">Name</th>
              <th className="py-3 px-4 text-left ">Email</th>
              <th className="py-3 px-4 text-left ">Role</th>
  
              <th className="py-3 px-4 text-center ">Actions</th>
            </tr>
          </thead>
          <tbody>
            {admins.map((admin) => (
              <tr
                key={admin._id}
                className="border-t p-5 border-gray-200 hover:bg-[var(--primary-solid)] hover:text-white transition"
              >
                <td className="py-3 px-4">{admin.fullName}</td>
                <td className="py-3 px-4">{admin.email}</td>
                <td className="py-3 px-4">{admin.role}</td>
              
                <td className="py-3 px-4 text-center flex justify-center gap-3">
                  <button
                    onClick={() => handleEdit(admin)}
                    className="hover:opacity-80"
                    title="Edit Employee"
                  >
                    <FaUserEdit />
                  </button>
                  <button
                    onClick={() => handleChangePassword(admin)}
                    className=" hover:opacity-80"
                    title="Change Password"
                  >
                    <FaLock />
                  </button>
                 
                  <button
                    onClick={() => {
                      setDeleteId(admin._id);
                      setShowConfirm(true);
                    }}
                    className="hover:opacity-80"
                    title="Delete Employee"
                  >
                    <FaTrash />
                  </button>

                </td>
              </tr>
            ))}
            {admins.length === 0 && (
              <tr>
                <td colSpan="5" className="py-6 text-center opacity-70">
                  No Employee found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Admin Edit/Create Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black flex justify-center items-center z-50">
          <div className="bg-white rounded-xl w-full max-w-md p-6 relative shadow-lg border-2 border-gray-200">
            <h3 className="text-xl font-semibold mb-4 text-[var(--primary-solid)]">
              {editAdmin ? "Edit Employee" : "Add New Employee"}
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4 text-[var(--black-text)]">
              <div>
                <label className="block text-sm font-medium mb-1">Full Name</label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                  className="w-full border-2 border-gray-200 rounded-md px-3 py-2 bg-white text-[var(--black-text)] focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full border-2 border-gray-200 rounded-md px-3 py-2 bg-white text-[var(--black-text)] focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
                />
              </div>
              {!editAdmin && (


                <div>
                  <label className="block text-sm font-medium mb-1">Password</label>
                  <div className="relative">
                    <input
                      type={showAddPass ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                      className="w-full border-2 border-gray-200 rounded-md px-3 py-2 bg-white text-[var(--black-text)] focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
                    />

                    <span
                      onClick={() => setShowAddPass(!showAddPass)}
                      className="absolute right-3 top-3 cursor-pointer"
                    >
                      {showAddPass ? <BsUnlockFill className="text-xl" /> : <IoMdLock className="text-xl" />}
                    </span>
                  </div>
                </div>



              )}
              <div>
                <label className="block text-sm font-medium mb-1">Role</label>
                <select
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  className="w-full border-2 border-gray-200 rounded-md px-3 py-2 bg-white text-[var(--black-text)] focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
                >
                  <option value="admin" className="bg-white">Admin</option>
                  <option value="super-admin" className="bg-white">Super Admin</option>
                  <option value="contributor" className="bg-white">contributor</option>
                </select>
              </div>

              <div className="flex justify-end gap-3 mt-4">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 rounded-md bg-white border-2 border-gray-200 text-[var(--black-text)] hover:bg-gradient-to-r hover:from-[var(--primary-solid)] hover:to-[var(--primary-dark)] hover:text-white transition"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 rounded-md bg-[var(--yellow)] text-[var(--black)]"
                >
                  {editAdmin ? "Update" : "Create"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Change Password Modal */}
      {showPasswordModal && (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
          <div className="bg-white rounded-xl w-full max-w-md p-6 relative shadow-lg border-2 border-gray-200">
            <h3 className="text-xl text-center font-semibold mb-4 text-[var(--primary-solid)]">
              Change Password for {selectedAdmin?.fullName}
            </h3>
            <form onSubmit={handlePasswordSubmit} className="space-y-4 text-[var(--black-text)]">

              {/* <label className="block text-sm font-medium ">Enter your currentPassword</label> */}
              {/* <div className="relative">

                <input
                  type={showCurrentPass ? "text" : "password"}
                  name="currentPassword"
                  value={passwordData.currentPassword}
                  onChange={handlePasswordChange}
                  required
                  className="w-full border-2 border-gray-200 rounded-md px-3 py-2 bg-white text-[var(--black-text)] focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
                />

                <span
                  onClick={() => setShowCurrentPass(!showCurrentPass)}
                  className="absolute right-3 top-3 cursor-pointer"
                >
                  {showCurrentPass ? <BsUnlockFill className="text-xl" /> : <IoMdLock className="text-xl" />}
                </span>
              </div> */}


              <label className="block text-sm font-medium ">Enter your newPassword</label>
              <div className="relative">

                <input
                  type={showNewPass ? "text" : "password"}
                  name="newPassword"
                  value={passwordData.newPassword}
                  onChange={handlePasswordChange}
                  required
                  className="w-full border-2 border-gray-200 rounded-md px-3 py-2 bg-white text-[var(--black-text)] focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
                />

                <span
                  onClick={() => setShowNewPass(!showNewPass)}
                  className="absolute right-3 top-3 cursor-pointer"
                >
                  {showNewPass ? <BsUnlockFill className="text-xl" /> : <IoMdLock className="text-xl" />}
                </span>
              </div>
              <label className="block text-sm font-medium ">Enter your confirmPassword</label>
              <div className="relative">

                <input
                  type={showNewPass ? "text" : "password"}
                  name="confirmPassword"
                  value={passwordData.confirmPassword}
                  onChange={handlePasswordChange}
                  required

                  className="w-full border-2 border-gray-200 rounded-md px-3 py-2 bg-white text-[var(--black-text)] focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
                />

                <span
                  onClick={() => setShowNewPass(!showNewPass)}
                  className="absolute right-3 top-3 cursor-pointer"
                >
                  {showNewPass ? <BsUnlockFill className="text-xl" /> : <IoMdLock className="text-xl" />}
                </span>
              </div>


              <div className="flex justify-between w-full text-center gap-3 mt-4">
                <button
                  type="button"
                  onClick={() => setShowPasswordModal(false)}
                  className="px-4 py-2 rounded-md bg-white border-2 border-gray-200 text-[var(--black-text)] hover:bg-gradient-to-r hover:from-[var(--primary-solid)] hover:to-[var(--primary-dark)] hover:text-white transition"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 rounded-md bg-[var(--yellow)] text-[var(--black)]"
                >
                  Update Password
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      <ConfirmModal
        isOpen={showConfirm}
        title="Delete Confirmation"
        message="Are you sure you want to delete this employee? This action cannot be undone."
        block="Yes, Delete"
        onCancel={() => setShowConfirm(false)}
        onConfirm={confirmDelete}
      />

    </div>
  );
}

